import {getUserData, getUserRole} from '../helpers'

export default (to, from, next) => {
  if (!getUserData()) {
    return next()
  }

  const currentUserRole = getUserRole().role
  const baseRedirect = currentUserRole === 'user' ? '/user' : '/admin'

  next(baseRedirect)
}



// WEBPACK FOOTER //
// /src/middleware/checkAuth.js